import { HOST } from '@/consts';
import { MAIN_WORLD, WORLD_NAME, worldResource, worldSocket } from '@/world';

type Config = {
  host: string;
  staticHost: boolean;
  title: string;
  creditsUrl: string;
  soundFont: string;
};

export function getDefaultConfig(): Config {
  return {
    host: MAIN_WORLD ? worldSocket() : HOST,
    staticHost: true,
    title: `EOWorld — ${WORLD_NAME}`,
    creditsUrl: 'https://github.com/sorokya/eoweb',
    soundFont: 'TimGM6mb.sf2',
  };
}

export async function loadConfig(): Promise<Config> {
  try {
    const response = await fetch(worldResource('/config.json'), { cache: 'no-store' });
    if (!response.ok) {
      return getDefaultConfig();
    }

    const config = await response.json();
    // Main must never fall back to Legacy, even if a config file was copied.
    return { ...config, host: MAIN_WORLD ? worldSocket() : config.host, title: `EOWorld — ${WORLD_NAME}` };
  } catch (_err) {
    return getDefaultConfig();
  }
}
